import React from 'react';

function CustomBlock({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M12.7208 3.17468L19.2008 6.51879C19.4707 6.65722 19.6978 6.87061 19.8567 7.13498C20.0155 7.39935 20.0997 7.70421 20.0999 8.01528V15.9826C20.0997 16.2937 20.0155 16.5986 19.8567 16.8629C19.6978 17.1273 19.4707 17.3407 19.2008 17.4791L12.7208 20.8232C12.4958 20.9395 12.2475 21 11.9959 21C11.7442 21 11.496 20.9395 11.2709 20.8232L4.79094 17.4791C4.52131 17.3389 4.29502 17.1237 4.13759 16.8578C3.98015 16.5919 3.89784 16.2859 3.89994 15.9743V8.01528C3.9001 7.70421 3.98433 7.39935 4.14317 7.13498C4.302 6.87061 4.52914 6.65722 4.79904 6.51879L11.279 3.17468C11.503 3.05979 11.7498 3 11.9999 3C12.2501 3 12.4968 3.05979 12.7208 3.17468V3.17468Z" />
      <path d="M3.8999 7.5L11.9999 11.1L20.0999 7.5" />
      <path d="M12 21.0001V11.1001" />
    </svg>
  );
}

export default CustomBlock;
